import { yup } from '@framework/validation';
import { IExpression } from './IExpression';
import { EvaluationScope } from './evaluate/EvaluationScope';
import { ExpressionValue } from './evaluate/ExpressionValue';
import { IReference } from './references/IReference';

export interface IExpressionType<TExpr extends IExpression = IExpression> {
  type: TExpr['type'];

  /**
   * Schema di validazione dell'espressione.
   */
  schema: yup.ObjectSchema<TExpr>;

  /**
   * Valuta un'espressione, sostituendo i riferimenti con i valori corrispondenti
   * e calcolando il risultato finale.
   */
  evaluate(expression: TExpr, scope: EvaluationScope): ExpressionValue;

  /**
   * Ottiene tutte le Reference utilizzate in un'espressione.
   */
  getReferences(
    expression: TExpr,
    collect: (expr: IExpression) => IReference[],
  ): IReference[];

  /**
   * Rappresentazione testuale dell'espressione.
   */
  toString(expression: TExpr, toString: (expr: IExpression) => string): string;
}

export function createExpressionType<TExpr extends IExpression>(
  expressionType: IExpressionType<TExpr>,
) {
  return expressionType;
}
